import { formatManaNumber } from "../../../utils/formatters";
import "./ManaIcon.css";

interface ManaIconProps {
  count?: number;
}

const ManaIcon = ({ count }: ManaIconProps) => {
  const countClassName = `mana-icon__count${
    count === 0 ? " mana-icon__count--zero" : ""
  }`;

  return (
    <div className="mana-icon">
      {count !== undefined && (
        <span className={countClassName}>{formatManaNumber(count)}</span>
      )}
      {/* <img
        src="/assets/img/ui/mana.webp"
        alt="Mana"
        className="mana-icon__image"
      /> */}
    </div>
  );
};

export default ManaIcon;
